"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationFinalizationWithTokenRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class RegistrationFinalizationWithTokenRequestDto {}
exports.RegistrationFinalizationWithTokenRequestDto = RegistrationFinalizationWithTokenRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'UUID returned from OTP verification or a Google Registration response'
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "registrationUuid", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'OTP code (deprecated if you already called /auth/register/otp/verify)',
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "otp", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Optional OTP-verified telephone number linked during registration',
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.Gender
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  description: 'Optional sub-gender; must belong to the selected gender when provided.'
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Whether to show gender preferences on the profile. Defaults to true.'
}), __metadata("design:type", Boolean)], RegistrationFinalizationWithTokenRequestDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Date of birth in MM-DD-YYYY format'
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.Gender,
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  enum: enums_1.Gender
}), __metadata("design:type", Array)], RegistrationFinalizationWithTokenRequestDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Optional JWT from /auth/register/photo/verify for the same photo uploaded as avatar. ' + 'When missing or invalid, registration still completes but isPhotoVerified stays false.',
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "photoVerificationToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  required: false,
  description: 'Uploaded photo paths/URLs (first item treated as avatar)'
}), __metadata("design:type", Array)], RegistrationFinalizationWithTokenRequestDto.prototype, "photoPaths", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], RegistrationFinalizationWithTokenRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], RegistrationFinalizationWithTokenRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "deviceToken", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "deviceId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.UserDeviceType,
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationWithTokenRequestDto.prototype, "deviceType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], RegistrationFinalizationWithTokenRequestDto.prototype, "deviceVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], RegistrationFinalizationWithTokenRequestDto.prototype, "deviceModel", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], RegistrationFinalizationWithTokenRequestDto.prototype, "appVersion", void 0);
//# sourceMappingURL=RegistrationFinalizationWithTokenRequest.dto.js.map